import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { NewsGroup, PageNavigation, TopMenu } from "../../components";
import { getLanguage } from "../../utils/environment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import {
  ConsoleTopLeftAdd,
  ConsoleTopRightAdd,
  HomePageCenterAdd,
  NewsViewLeftBottomAdd,
  NewsViewRightTopAdd,
} from "../templates/advertiesments";
import Footer from "../footer/index";
import HotNewsSmall from "../templates/hotNewsSmall";
import { MobileMenuModal } from "../modal";
import Menu from "../templates/menu";
import { GetIconByName } from "../../config/icon";
import { openMobileMenuModal } from "../console/redux/actions";
import {
  downloadGazetteApplication,
  downloadJobApplication,
  getAllJobsCategory,
} from "../CreateNewItem/CreateNewJob/service/jobs.service";
import { getInsight, setInsight } from "../../utils";
import { setJobCategoryList } from "../Jobs/redux/actions";
import { createNewInsight } from "../console/services/insight.service";
import {
  addNewGazetteImpression,
  addNewJobsDownloadImpression,
} from "../GovernmentJobsPage/service/jobs.service";
import { getIPAddress } from "../../utils/browserMeta";
import { getGazetteById } from "../CreateNewItem/CreateNewGazette/service/jobs.service";
import GazetteDetailsViewCard from "../../components/gazetteDetailsViewCard";
import moment from "moment";
import RelatedJobs from "../templates/relatedJobs";
import HomeAdViewModal from "../modal/homeAdViewModal";
const lan = getLanguage();

const Index = (props) => {
  const [category, setCategory] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [jobCategory, setJobCategory] = React.useState([]);
  const [jobId, setJobId] = useState("");
  const [jobDetails, setJobDetails] = useState("");
  const [gazetteDetails, setGazetteDetails] = useState("");
  const [isSticky, setIsSticky] = useState(false);

  const dispatch = useDispatch();
  const { isOpenMobileMenuModal, isOpenAd } = useSelector(
    ({ consoleReducer }) => consoleReducer,
  );
  const { selectJobs, jobCategoryList } = useSelector(
    ({ jobsReducer }) => jobsReducer,
  );

  const selectGazette = useSelector((state) => state.jobsReducer.selectGazette);

  // const [filteredGazetteList, setFilteredGazetteList] = useState(
  //   gazetteList || []
  // );

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY >= 20);
      console.log(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  async function handleInsight(gazetteId) {
    let insightBody = {};
    try {
      console.log({ gazetteId });
      // Get the geolocation
      // const position = await getGeoLocation();
      // const { latitude, longitude, accuracy, timestamp } = position?.coords;

      // Wait for all promises to resolve
      const [ip] = await Promise.all([
        // getLocationName(latitude, longitude),
        getIPAddress(),
      ]);

      // Construct the insight body
      insightBody = {
        insight_id: null,
        ip,
        platform: "https://sinhala.hopeofanewera.org/",
        // user: sessionUser?.userId,
      };

      const insight = await getInsight();
      // Additional logic for when the insight is found
      if (insight?.insight_id) {
        console.log("userInsight_insight_found", insight);
        insightBody.insight_id = insight.insight_id;
        let impressionBody = {
          insight_id: insight.insight_id,
          gazette_id: gazetteId,
          ip_address: ip,
        };

        let resImpression = await addNewGazetteImpression(impressionBody);
        console.log("addNew_Job_Impression::", resImpression);
        // setNews({ ...news, views: (news?.views || 0) + 1 });
      }
    } catch (error) {
      console.log("No insight found", error);
      try {
        const insightResponse = await createNewInsight(insightBody);
        console.log("Created new insight:", insightResponse);
        if (
          insightResponse?.data?.status ||
          insightResponse?.data?.data !== ""
        ) {
          await setInsight(insightResponse?.data?.data?.token);
          let impressionBody = {
            insight_id: insightResponse?.data?.data?.insight_id,
            gazette_id: gazetteId,
            ip_address: insightBody.ip,
          };

          let resImpression = await addNewGazetteImpression(impressionBody);
          console.log("addNew_Job_Impression::", resImpression);
          // setNews({ ...news, views: (news?.views || 0) + 1 });
        }

        // Additional logic for when the insight is not found and a new one is created
      } catch (creationError) {
        console.error("Error creating new insight:", creationError);
        // Handle the error that occurred during the creation of a new insight
      }
    }
  }

  const fetchData = async () => {
    setIsLoading(true);

    let param = window.location.pathname.split("/");
    console.log({ param });
    try {
      if (param.length > 2) {
        const gazette_id = param[3];
        console.log({ param });

        const getList = await getGazetteById(gazette_id);
        console.log("Get Gazette by Id : ", getList);
        setIsLoading(false);

        if (getList.data) {
          setGazetteDetails(getList?.data);
          await handleInsight(gazette_id);
        } else {
          console.log("Data Not Found");
        }
      }
    } catch (error) {
      console.log("Error fetching Campaign Data", error);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchData();
  }, []);

  async function handleInsightDownload(jobId, categoryId) {
    let insightBody = {};
    try {
      console.log({ jobId, categoryId });
      // Get the geolocation
      // const position = await getGeoLocation();
      // const { latitude, longitude, accuracy, timestamp } = position?.coords;

      // Wait for all promises to resolve
      const [ip] = await Promise.all([
        // getLocationName(latitude, longitude),
        getIPAddress(),
      ]);

      // Construct the insight body
      insightBody = {
        insight_id: null,
        ip,
        platform: "https://hopeofanewera.org/",
        // user: sessionUser?.userId,
      };

      console.log("userInsight_insightBody:", insightBody);
      const insight = await getInsight();
      console.log("Insight found", insight);
      // Additional logic for when the insight is found
      if (insight?.insight_id) {
        console.log("userInsight_insight_found", insight);
        insightBody.insight_id = insight.insight_id;
        let impressionBody = {
          insight_id: insight.insight_id,
          job_id: jobId,
          category_id: categoryId,
          ip_address: ip,
        };

        let resImpression = await addNewJobsDownloadImpression(impressionBody);
        console.log("addNew_Job_Impression::", resImpression);
        // setNews({ ...news, views: (news?.views || 0) + 1 });
      }
    } catch (error) {
      console.log("No insight found", error);
      try {
        const insightResponse = await createNewInsight(insightBody);
        console.log("Created new insight:", insightResponse);
        if (
          insightResponse?.data?.status ||
          insightResponse?.data?.data !== ""
        ) {
          await setInsight(insightResponse?.data?.data?.token);
          let impressionBody = {
            insight_id: insightResponse?.data?.data?.insight_id,
            job_id: jobId,
            category_id: categoryId,
            ip_address: insightBody.ip,
          };

          let resImpression =
            await addNewJobsDownloadImpression(impressionBody);
          console.log("addNew_Job_Impression::", resImpression);
          // setNews({ ...news, views: (news?.views || 0) + 1 });
        }

        // Additional logic for when the insight is not found and a new one is created
      } catch (creationError) {
        console.error("Error creating new insight:", creationError);
        // Handle the error that occurred during the creation of a new insight
      }
    }
  }

  const handleChildData = (childData) => {
    // props.onChangeCategory(childData); // Update state with child data
    setCategory(childData);
  };

  const openWindow = async (imgUrl, gazette_id) => {
    const adUrlRight = process.env.REACT_APP_HOME_TOP_RIGHT_ADV;
    const adUrlLeft = process.env.REACT_APP_HOME_TOP_LEFT_ADV;

    const insight = await getInsight(); // Assuming this returns { insight_id }
    try {
      await handleInsight(gazette_id);
    } catch (error) {
      console.log(error);
    }

    // const isPdf = imgUrl.endsWith(".pdf");
    let previewElement = "";
    console.log("Array.isArray(imgUrl)", Array.isArray(imgUrl));
    if (Array.isArray(imgUrl)) {
      previewElement = imgUrl
        .map((img, id) => {
          const src = img?.file_url;
          if (src?.endsWith(".pdf")) {
            return `<iframe src="${src}" alt="${id}" class="responsive-content"></iframe>`;
          } else {
            return `<img src="${src}" alt="${id}" class="responsive-content" />`;
          }
        })
        .join("");
    } else {
      previewElement = imgUrl?.endsWith(".pdf")
        ? `<iframe src="${imgUrl}" alt="PDF" class="responsive-content"></iframe>`
        : `<img src="${imgUrl}" alt="job details sinhala" class="responsive-content" />`;
    }

    const newWindow = window.open("", "", "width=1024,height=920");
    if (newWindow) {
      const safeAdUrlRight = adUrlRight || "";
      const safeAdUrlLeft = adUrlLeft || "";

      newWindow.document.write(`
    <html>
      <head>
        <title>Preview</title>
        <style>
          html, body {
            margin: 0;
            padding: 0;
            height: 100%;
            width: 100%;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
          }

          .advertisement-wrapper {
            display: flex;
            flex-direction: row;
            justify-content: center;
            gap: 10px;
            height: 80px;
            flex-shrink: 0;
          }

          .top-ad {
            flex: 1;
            height: 100%;
          }

          .top-ad iframe {
            width: 100%;
            height: 100%;
            border: none;
          }

          .content-container {
            flex: 1;
            /*overflow: auto;*/
            display: flex;
            justify-content: center;
            align-items: center;
            background: #f8f8f8;
          }

          .responsive-content {
            max-width: 100%;
            max-height: 100%;
            width: 100%;
            height: 100%;
            object-fit: contain;
            border: none;
          }
        </style>
      </head>
      <body>
        <div class="advertisement-wrapper">
          <div class="top-ad">
            <iframe id="adFrameLeft" src="${safeAdUrlLeft}" loading="lazy"></iframe>
          </div>
          <div class="top-ad">
            <iframe id="adFrameRight" src="${safeAdUrlRight}" loading="lazy"></iframe>
          </div>
        </div>
        <div class="content-container"  style="display: flex; flex-direction: column;">
          ${previewElement}
        </div>
        <script>
          window.addEventListener('load', function () {
            const iframeLeft = document.getElementById('adFrameLeft');
            const iframeRight = document.getElementById('adFrameRight');

            iframeLeft?.addEventListener('load', function () {
              iframeLeft.contentWindow?.postMessage(
                { insight_id: "${insight?.insight_id || ""}" },
                "${safeAdUrlLeft}"
              );
            });

            iframeRight?.addEventListener('load', function () {
              iframeRight.contentWindow?.postMessage(
                { insight_id: "${insight?.insight_id || ""}" },
                "${safeAdUrlRight}"
              );
            });
          });
        </script>
      </body>
    </html>
  `);
      newWindow.document.close();
    }
  };

  const onClickDownloadApplication = async (gazette_id, lan, type) => {
    setIsLoading(true);
    try {
      if (
        type === "gazette" &&
        gazetteDetails?.job_details?.[`${lan}_url`]?.[0]?.file_url?.endsWith(
          ".pdf",
        )
      ) {
        const url = gazetteDetails?.job_details?.[`${lan}_url`]?.[0]?.file_url;

        if (url.endsWith(".pdf")) {
          window.open(url, "_blank");
        } else {
          const a = document.createElement("a");
          a.href = url;
          a.download = `gazette_${gazette_id}_${lan}`;
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
        setIsLoading(false);
      } else if (
        type === "procurement" &&
        gazetteDetails?.procurement_details?.[
          `${lan}_url`
        ]?.[0]?.file_url?.endsWith(".pdf")
      ) {
        const url =
          gazetteDetails?.procurement_details?.[`${lan}_url`]?.[0]?.file_url;

        if (url.endsWith(".pdf")) {
          window.open(url, "_blank");
        } else {
          const a = document.createElement("a");
          a.href = url;
          a.download = `gazette_${gazette_id}_${lan}`;
          document.body.appendChild(a);
          a.click();
          a.remove();
        }
        setIsLoading(false);
      } else {
        let response = await downloadGazetteApplication(gazette_id, lan, type);
        console.log("response download::", response);
        if (response?.data) {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = `gazette_${gazette_id}_${lan}.pdf`; // Optional: Make dynamic with job_id
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);

          alert("Downloaded");
          setIsLoading(false);
          window.scrollTo(0, 0);
        }
      }

      // setIsLoading(false);
    } catch (error) {
      console.log({ error });
      setIsLoading(false);
    }
  };

  const fetchCategories = async () => {
    const response = await getAllJobsCategory();
    if (response?.data) {
      setJobCategory(response.data);
      dispatch(setJobCategoryList(response.data));
    }
  };

  useEffect(() => {
    if (jobCategoryList?.length === 0) {
      fetchCategories();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>{jobDetails?.job_title?.[lan] || "Government Gazette"}</title>
        <meta
          name="description"
          content={
            jobDetails?.summary?.[lan]?.slice(0, 150) || "Government Gazette."
          }
        />
        <meta property="og:title" content={jobDetails?.job_title?.[lan]} />
        <meta
          property="og:description"
          content={jobDetails?.description?.[lan]?.slice(0, 150)}
        />
        <meta property="og:image" content={jobDetails?.banner_img?.file_url} />
        <meta property="og:url" content={window.location.href} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            headline: jobDetails?.job_title?.[lan],
            image: [jobDetails?.banner_img?.file_url],
            datePublished: jobDetails?.created_at,
            dateModified: jobDetails?.updated_at || jobDetails?.created_at,
            author: {
              "@type": "Organization",
              name: "Hope of a New Era",
            },
            publisher: {
              "@type": "Hope of a New Era",
              name: "Hope of a New Era",
              logo: {
                "@type": "ImageObject",
                url: "https://example.com/logo.png",
              },
            },
          })}
        </script>
      </Helmet>
      <>
        {isOpenMobileMenuModal && <MobileMenuModal />}
        {isOpenAd && <HomeAdViewModal />}
        <div className={`cw__top-menu ${isSticky ? "sticky" : ""}`}>
          <TopMenu
            data={{
              size: "lg",
              isLanguage: true,
              isLogo: false,
              isProfile: false,
            }}
            onClickPublish={() => {
              props.history.push("/admin");
            }}
          />
        </div>
        <div className={"container"}>
          <div className={`cw__tab ${isSticky ? "sticky" : ""} `}>
            <div className={"cwt__hope"}>
              <img
                src={require("../../assets/img/lgo (1).png")}
                alt={jobDetails?.job_title?.[lan]}
              />
            </div>
            <div className={"menu"}>
              <Menu setMenuName={handleChildData} />
            </div>

            {/* <div
              className={"cwt__menu-mobile"}
              onClick={() => {
                dispatch(openMobileMenuModal());
              }}
            >
              {GetIconByName("menu")}
            </div> */}
          </div>
          <div className={"cw__advertiesment-wrapper"}>
            <ConsoleTopLeftAdd />
            <ConsoleTopRightAdd />
          </div>

          <div className="gov-date-filter">
            <PageNavigation
              data={{
                main: "Gazette",
                page: (
                  <>
                    Sri Lanka Government Gazette{" "}
                    <span
                      style={{
                        color: "#fa1c69",
                        fontWeight: "bold",
                        textDecoration: "none",
                      }}
                    >
                      {moment(gazetteDetails?.gazette_date).format(
                        "YYYY MMMM DD",
                      )}
                    </span>
                  </>
                ),
              }}
              onClick={() => props.history.push("/government-gazette")}
            />
          </div>

          <div className={`gov-gazette-details-view-wrapper`}>
            <div className={"gj__special-news-group"}>
              <div className="sng-main">
                <NewsGroup
                  data={{
                    titleName:
                      "Gazette - " +
                      moment(gazetteDetails?.gazette_date).format(
                        "YYYY MMMM DD",
                      ),
                    // linkName: "තවත් පුවත්",
                    // linkName: (
                    //   <>
                    //     {pageCount > news?.length && (
                    //       <div
                    //         className={
                    //           "d-flex flex-column justify-content-center align-items-center mt-5"
                    //         }
                    //       >
                    //         <Pagination
                    //           data={{
                    //             paginationCount: pageCount,
                    //             pageNo: pageNo,
                    //           }}
                    //           onChange={onChangePage}
                    //         />
                    //       </div>
                    //     )}
                    //   </>
                    // ),
                  }}
                  // onClickViewNews={() => {
                  //   onChangePage(pageNo + 1);
                  // }}
                >
                  <div className="pl-3 pr-3">
                    <GazetteDetailsViewCard
                      // key={gazette?.gazette_id}
                      titleEn={
                        "Gazette of the Democratic Socialist Republic of Sri Lanka"
                      }
                      titleSi={
                        "ශ්‍රී ලංකා ප්‍රජාතාන්ත්‍රික සමාජවාදී ජනරජයේ ගැසට් පත්‍ර"
                      }
                      gazetteDate={gazetteDetails?.gazette_date}
                      organization={gazetteDetails?.tags}
                      views={gazetteDetails?.views}
                      attachmentSI={gazetteDetails?.job_details?.si_url}
                      attachmentEN={gazetteDetails?.job_details?.en_url}
                      attachmentTA={gazetteDetails?.job_details?.ta_url}
                      procurementSI={
                        gazetteDetails?.procurement_details?.si_url
                      }
                      procurementEN={
                        gazetteDetails?.procurement_details?.en_url
                      }
                      procurementTA={
                        gazetteDetails?.procurement_details?.ta_url
                      }
                      onClickDownloadSI={async () => {
                        console.log("onClickDownloadSI");
                        await onClickDownloadApplication(
                          gazetteDetails?.gazette_id,
                          "si",
                          "gazette",
                        );
                      }}
                      onClickDownloadEN={async () => {
                        await onClickDownloadApplication(
                          gazetteDetails?.gazette_id,
                          "en",
                          "gazette",
                        );
                      }}
                      onClickDownloadTA={async () => {
                        await onClickDownloadApplication(
                          gazetteDetails?.gazette_id,
                          "ta",
                          "gazette",
                        );
                      }}
                      onClickProcurementDownloadSI={async () => {
                        console.log("onClickProcurementDownloadSI");
                        await onClickDownloadApplication(
                          gazetteDetails?.gazette_id,
                          "si",
                          "procurement",
                        );
                      }}
                      onClickProcurementDownloadEN={async () => {
                        await onClickDownloadApplication(
                          gazetteDetails?.gazette_id,
                          "en",
                          "procurement",
                        );
                      }}
                      onClickProcurementDownloadTA={async () => {
                        await onClickDownloadApplication(
                          gazetteDetails?.gazette_id,
                          "ta",
                          "procurement",
                        );
                      }}
                    />
                  </div>
                </NewsGroup>
              </div>

              <div className="bottom-ad">
                <NewsViewLeftBottomAdd />
              </div>

              <div className="bottom-ad-mobile">
                <HomePageCenterAdd />
              </div>

              <RelatedJobs date={gazetteDetails?.gazette_date} />
            </div>

            <div className={"gj__special-news-group"}>
              <NewsViewRightTopAdd data={{ mainLayerStyles: "mb-3" }} />
              <HotNewsSmall setMenuName={handleChildData} />
            </div>
          </div>
        </div>
        <Footer />
      </>
    </>
  );
};

export default withRouter(Index);
